module.exports = __webpack_public_path__ + "img/641.cb256656.gif";